/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
//import { toAbsoluteUrl } from "../../../_private/helpers";
import styled from "styled-components";
//import hqLogo from "../../../_private/assets/HQlOGO.png";
import mainLogo from "../../../../src/images/mainlogo.png";

/* CSS for HQ Panel Logo */
// const LogoContainer = styled.div`
// font-family: Arial, sans-serif;
// font-weight: bold;
// font-size: 30px;
// color: #333;
// text-transform: uppercase;
// letter-spacing: 2px;
// text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
// margin-bottom: 15px;
// `;

// const LogoText = styled.span`
// background-color: #007bff;
// color: var(--bs-text-white) !important;
// padding: 8px 16px;
// border-radius: 5px;
// `;

const AuthLayout = () => {
	useEffect(() => {
		const root = document.getElementById("root");
		if (root) {
			root.style.height = "100%";
		}
		return () => {
			if (root) {
				root.style.height = "auto";
			}
		};
	}, []);

	return (
		<div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
			{/* begin::Aside */}
			<div className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1'
				style={{ background: "#080808" }}>
				{/* begin::Content */}
				<div className="overlay_sec">
					<div className='d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100'>
						{/* begin::Logo */}
						<div className="signin_right_bg">
							<img className="d-lg-block mx-auto w-275px w-md-500 w-xl-500px w-lg-300" src={mainLogo} alt='mainlogo' />

						</div>
						<p style={{ color: "#696969" }} className="cpyr8_sec position-md-fixed position-sm-static position-md-static" >COPYRIGHT 2026 SLOTSDIAMOND 3. ALL RIGHTS RESERVED.</p>
						{/* end::Logo */}

						{/* begin::Title */}
						{/* <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
								Fast, Efficient and Productive
							</h1> */}
						{/* end::Title */}
					</div>
				</div>
				{/* end::Content */}
			</div>
			{/* end::Aside */}
			{/* begin::Body */}
			<div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2'>
				{/* begin::Form */}
				<div className='d-flex flex-center flex-column flex-lg-row-fluid'>
					{/* begin::Wrapper */}
					<div className='w-lg-500px p-10'>
						<Outlet />
					</div>
					{/* end::Wrapper */}
				</div>
				{/* end::Form */}
			</div>
			{/* end::Body */}


		</div>
	);
};

export { AuthLayout };
